import { fetchWithAuth } from "../api/client";
import { RoleEntity } from "../types";

export async function getRoles(token: string): Promise<RoleEntity[]> {
  const res = await fetchWithAuth("Role", {
    method: "GET",
    token,
  });

  if (!res.ok) {
    throw new Error(`Error fetching roles: ${res.statusText}`);
  }

  return await res.json();
}
